import { FC } from 'react'

import { GroupedPill } from '@joor/design-system'
import styled from 'styled-components'

import { Pill } from './pillGroup.types'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  line-height: 16px;
`

const PillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: inherit;
`

const PillWrapper = styled.div`
  margin-right: 2px;
`

type Props = {
  visiblePills: Pill[]
  groupedPills: Pill[]
  pillComponent: ({ value }: { value: Pill }) => JSX.Element
}

export const PillGroup: FC<Props> = ({
  visiblePills,
  groupedPills,
  pillComponent,
}) => (
  <Container>
    <PillsContainer>
      {visiblePills.map((pill) => (
        <PillWrapper key={pill.id}>
          {pillComponent({ value: pill })}
        </PillWrapper>
      ))}
    </PillsContainer>
    {groupedPills.length > 0 && (
      <GroupedPill>
        {groupedPills.map((pill) => pillComponent({ value: pill }))}
      </GroupedPill>
    )}
  </Container>
)
